import {combineReducers} from 'redux';
import {workSpaceSliceReducer} from './workspace/workSpaceSlice';
import {sessionSliceReducer} from './auth/sessionSlice';
import {boardSliceReducer} from './boards/boardSlice';
import {appDrawerSliceReducer} from './themeSettings/drawers/appDrawerSlice';
import {itemStatusSliceReducer} from './itemStatues';
import {boardItemDialogSliceReducer} from './boardItemDialogStore';
import {ColumnOrderSliceReducer} from './kanban/columnOrderSlice';
import {configurationSliceReducer} from './Theme';
import {timeTrackerSliceReducer} from './timeTracker/timeTrackerSlice';
import {notificationSliceReducer} from './notification/notificationSlice';
import {sprintSliceReducer} from './sprints/sprintSlice';
import {myWorkSliceReducer} from './mywork/myworkSlice';

const combinedReducer = combineReducers({
    session: sessionSliceReducer,
    workSpaces: workSpaceSliceReducer,
    boards: boardSliceReducer,
    sprints: sprintSliceReducer,
    itemStatues: itemStatusSliceReducer,
    boardItemDialog: boardItemDialogSliceReducer,
    columnOrder: ColumnOrderSliceReducer,
    drawer: appDrawerSliceReducer,
    configurations: configurationSliceReducer,
    timeTracker: timeTrackerSliceReducer,
    myWork: myWorkSliceReducer,
    // Add other reducers here
    notification: notificationSliceReducer,
});

const rootReducer = (asyncReducers?: any) => (state: any, action: any) => {
    if (action.type === 'session/clearSession') {
        state = undefined; // Reset the state on sign out
        // this applies to all keys defined in persistConfig(s)
    }
    return combinedReducer(state, action);
};
export default rootReducer;
export type RootState = ReturnType<typeof combinedReducer>;
